import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { useAuth } from "@/contexts/AuthContext";

export const SentryUserContextSync = () => {
  const { user, loading, isSuperAdmin, currentTenantId, currentFactoryId, currentLineId } = useAuth();

  useEffect(() => {
    if (!Sentry.isEnabled() || loading) {
      return;
    }

    if (!user) {
      Sentry.setUser(null);
      Sentry.setTag("auth.state", "anonymous");
      Sentry.setTag("tenant.id", "none");
      Sentry.setTag("factory.id", "none");
      Sentry.setTag("line.id", "none");
      Sentry.setContext("auth", { authenticated: false });
      return;
    }

    const fallbackName = typeof user.user_metadata?.full_name === "string"
      ? user.user_metadata.full_name
      : undefined;

    Sentry.setUser({
      id: user.id,
      email: user.email ?? undefined,
      username: fallbackName,
      tenant_id: currentTenantId ?? undefined,
      factory_id: currentFactoryId ?? undefined,
      line_id: currentLineId ?? undefined,
    });

    Sentry.setTag("auth.state", "authenticated");
    Sentry.setTag("tenant.id", currentTenantId ?? "none");
    Sentry.setTag("factory.id", currentFactoryId ?? "none");
    Sentry.setTag("line.id", currentLineId ?? "none");
    Sentry.setContext("auth", {
      authenticated: true,
      user_id: user.id,
      email: user.email,
      full_name: fallbackName,
      tenant_id: currentTenantId,
      factory_id: currentFactoryId,
      line_id: currentLineId,
      is_super_admin: isSuperAdmin,
    });
  }, [loading, user, currentTenantId, currentFactoryId, currentLineId, isSuperAdmin]);

  return null;
};
